import { IOfferSpendByOfferScopeListTableLang } from '../../../types/lang'

export const offerSpendByOfferScopeListTableLang: IOfferSpendByOfferScopeListTableLang = {
	offer_spend_by_offer_scope_list_table: {
		column_scope_id: 'Scope ID_ua',
		column_scope: 'Scope_ua',
		column_scope_in_group: 'Scope in Group_ua',
		column_amount: 'Amount_ua',
		column_date: 'Date_ua',
	}
}